<template>
    <div id="regali-aziendali" class="mt-lg-4">
        <RotateCards />
        <InfoBottom />
    </div>
</template>

<script>
    export default {
        name: 'regali-aziendali',
        components: {
            RotateCards: () => import('@/components/views/regali-aziendali/rotate-cards').then(function(RotateCards) {
                if(process.env.VUE_APP_MODE != 'production') window.console.log('async: RotateCards Component loaded')
                return RotateCards
            }),             
            InfoBottom: () => import('@/components/blocks/info-bottom').then(function(InfoBottom) {
                if(process.env.VUE_APP_MODE != 'production') window.console.log('async: InfoBottom Component loaded')
                return InfoBottom
            }),        
        },
        data()
        {
            return {
            }
        },
        methods: {
        },
        mounted()
        {
        }
    }
</script>

<style lang="scss">
    #regali-aziendali
    {

    }
</style>